import { Outlet, useLocation } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import Alert from 'utils/Alert'
import Loader from 'utils/Loader'
import { loadingState } from '../global/LoaderState'
import Footer from './Footer'
import Header from './Header'

function Layout() {
  const location = useLocation()
  const isLoginPage =
    location.pathname === '/' ||
    location.pathname === '/login' ||
    location.pathname === '/sign-in'
  const [isLoading, setLoading] = useRecoilState(loadingState)

  return (
    <>
      <Header />
      <div style={{ minHeight: '100vh' }}>
        <Outlet />
      </div>
      {!isLoginPage && !isLoading && <Footer />}
    </>
  )
}

export default Layout
